import React from 'react';
import ChangePassword from '../components/ui/ChangePassword';
import MobligoLogo from '../assets/img/mobligo_new.png';

const ChangePasswordPage = () => {
  return (
    <div className="authPage d-flex overflow-auto">
      <div className="login bg-[#ffffff] h-[100vh] overflow:hidden flex justify-center">
        <div className="relative flex flex-row flex-wrap items-center justify-center h-[100%]">
          <div className="z-[1000] w-[300px] sm:w-[500px] bg-[#FFFFFF] rounded-xl">
            <div className="flex flex-col justify-center  items-center gap-3 h-max">
              <a className="w-full flex items-center justify-center" href="/">
                <img className="w-[70%] xl:w-[43%] lg:w-[43%] mt-5" src={MobligoLogo} alt="" />
              </a>
              <ChangePassword />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordPage;
